<template>
  <div v-resize="onResize" style="padding: 0; margin: 0">
    <div style="border-bottom: 1px solid #eee; " v-if="hasAlternative && !isLineShopping">
      <v-layout>
        <v-flex class="pl-3">
          <template v-if="input.randomStatus">
            {{ $t('Random chatbot answers') }}
          </template>
          <template v-else>
            {{ $t('Chatbot answers') }}
          </template>
        </v-flex>
        <v-flex shrink class="text-xs-right">
          <v-dialog v-model="showSetting" max-width="800" persistent>
            <v-card>
              <div class="text-xs-right">
                <v-btn @click="showSetting = false" small fab flat><v-icon>close</v-icon></v-btn>
              </div>
              <v-card-text class="text-xs-left">
                <template v-if="!isBeacon">
                  <div class="primary--text">
                    {{ $t('Reply Setting') }}
                    <a href="https://tinyurl.com/5n87u5hc" target="blank"
                      ><i
                        style="font-size: 1.3em; color: #ed1e79;"
                        class="fas fa-question-circle"
                      ></i
                    ></a>
                    <!-- <v-premium-lock2
                      v-if="!check_privilege('multichannel')"
                      :inline="true"
                      class="ml-2"
                      type="advanced"
                      text="This function is only available for the Advanced Package. Starting at 990 baht / month ,click to upgrade."
                    ></v-premium-lock2> -->
                  </div>

                  <v-radio-group v-model="input.showMultipleChannel" row>
                    <v-radio
                      :label="$t('Same Reply to all Channels')"
                      :value="false"
                      color="primary"
                    ></v-radio>
                    <v-radio
                      class="mr-1"
                      :label="$t('Seperate Reply')"
                      :value="true"
                      color="primary"
                      :disabled="isOutOfTime"
                    ></v-radio>
                    <div v-if="isOutOfTime && !check_privilege('multichannel')">
                      <v-premium-lock2
                        type="advanced"
                        text="This function is only available for the Advanced package. Starting at 990 baht / month ,click to upgrade."
                      ></v-premium-lock2>
                    </div>
                  </v-radio-group>
                </template>
                <template v-if="isBeacon">
                  <strong>{{ $t('How to set random chatbot responses?') }}</strong>
                  <ul>
                    <li>{{ $t('1. Press the “Random Answers” ​​button to turn green.') }}</li>
                    <li>
                      {{
                        $t(
                          '2. Choose 1-5 random answer patterns and put the desired answer in each format.^^'
                        )
                      }}
                    </li>
                  </ul>
                </template>
                <template v-if="!isVerifySlip">
                  <div class="primary--text mt-3">
                    {{ $t('Random answer') }}
                    <a href="https://blog.zwiz.app/randomanswer/" target="blank"
                      ><i
                        style="font-size: 1.3em; color: #ed1e79;"
                        class="fas fa-question-circle"
                      ></i
                    ></a>
                  </div>
                  <toggle-button
                    class="mt-2"
                    :value="input.randomStatus"
                    :sync="true"
                    :color="$vuetify.theme.success"
                    @change="toggleRandomStatus"
                    :labels="{ checked: 'ON', unchecked: 'OFF' }"
                    style="display: inline-block"
                  />
                </template>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn @click="changeSetting" color="primary">
                  {{ $t('Save') }}
                </v-btn>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-dialog>

          <template v-if="isBeacon">
            <v-btn
              class="ma-0 extra-small"
              v-if="$route.name != 'Setup'"
              small
              outline
              color="primary"
              @click="showSetting = true"
            >
              {{ $t('Random answers') }}
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              class="ma-0 extra-small"
              v-if="$route.name != 'Setup'"
              fab
              flat
              small
              color="grey"
              @click="showSetting = true"
            >
              <v-icon>settings</v-icon>
            </v-btn>
          </template>
        </v-flex>
      </v-layout>
    </div>
    <div>
      <div ref="randomBar"></div>
      <template v-if="input.randomStatus && !isVerifySlip">
        <!-- Random Intent -->
        <v-layout class="mb-2">
          <v-flex>
            <v-tabs
              v-model="currentAlternative"
              :show-arrows="true"
              slider-color="primary"
              :style="{ 'max-width': maxRandomBarWidth + 'px' }"
            >
              <v-tab v-for="n in intentItems.length" :key="n" ripple>
                {{ $t('pattern') }} {{ n }}
                <v-btn
                  @click="onDeleteAlternative(n)"
                  :disabled="intentItems.length == 1"
                  fab
                  flat
                  small
                  class="mr-0"
                  style="width: 25px; height: 25px;"
                >
                  <v-icon small>close</v-icon>
                </v-btn>
              </v-tab>
            </v-tabs>
          </v-flex>
          <v-flex shrink>
            <v-btn
              class="extra-small mt-2"
              @click="nextAlternative"
              fab
              small
              outline
              color="black"
              :disabled="intentItems.length >= 5 || currentAlternative >= 4"
              v-tooltip.top="$t('In case, user wants to random reply messages')"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <div class="mt-2"></div>
      <template v-if="isVerifySlip">
        <template v-for="i in correctMsg.length">
          <transition
            v-on:before-enter="beforeEnter"
            v-on:enter="enter"
            v-on:after-enter="afterEnter"
            v-on:before-leave="beforeLeave"
            v-on:leave="leave"
            v-on:after-leave="afterLeave"
            :key="`${i}_${timestamp}`"
          >
            <intent-verify-slip
              class="intent-group-item"
              :isIgType="isIgType"
              :key="`alternative_${i}_${timestamp}`"
              :isWelcome="isWelcome"
              :isBroadCast="isBroadCast"
              :indexAlternative="i"
              :intentname="intentname"
              :channel="channel"
              :availableBubbles="availableBubbles"
              :isHasPrefill="isHasPrefill"
              :followUp="followUp"
              :isBeacon="isBeacon"
              :isIntent="isIntent"
              :messagesType="messagesType"
              :maxLength="maxLength"
              :isNotAltText="isNotAltText"
              :isNotRatio="isNotRatio"
              :groupType="groupType"
              :customType="customType"
              :isLineShopping="isLineShopping"
              :isAdsPreview="isAdsPreview"
              :isFirstAnnouncement="isFirstAnnouncement"
              :isVerifySlip="isVerifySlip"
              :correct.sync="correctMsg[i - 1]"
              :incorrect.sync="incorrectMsg[i - 1]"
              :err.sync="errMsg[i - 1]"
              :duplicate.sync="duplicateMsg[i - 1]"
              @clearToWayVerify="$emit('clearToWayVerify')"
              v-if="isVerifySlip"
            ></intent-verify-slip>
          </transition>
        </template>
      </template>
      <template v-else-if="intentItems">
        <template v-for="i in intentItems.length">
          <transition
            v-on:before-enter="beforeEnter"
            v-on:enter="enter"
            v-on:after-enter="afterEnter"
            v-on:before-leave="beforeLeave"
            v-on:leave="leave"
            v-on:after-leave="afterLeave"
            :key="`${i}_${timestamp}`"
          >
            <intent-group-item
              @clearToWayVerify="$emit('clearToWayVerify')"
              class="intent-group-item"
              v-model="intentItems[i - 1]"
              :isIgType="isIgType"
              :key="`alternative_${i}_${timestamp}`"
              :isWelcome="isWelcome"
              :isBroadCast="isBroadCast"
              :indexAlternative="i"
              :intentname="intentname"
              :channel="channel"
              :availableBubbles="availableBubbles"
              :isHasPrefill="isHasPrefill"
              :followUp="followUp"
              :isBeacon="isBeacon"
              :isIntent="isIntent"
              :messagesType="messagesType"
              :maxLength="maxLength"
              :isNotAltText="isNotAltText"
              :isNotRatio="isNotRatio"
              :groupType="groupType"
              :customType="customType"
              :isLineShopping="isLineShopping"
              :isAdsPreview="isAdsPreview"
              :isFirstAnnouncement="isFirstAnnouncement"
              :isVerifySlip="isVerifySlip"
              v-if="currentAlternative == i - 1"
            ></intent-group-item>
          </transition>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import IntentGroupItem from './IntentGroupItem.vue'
import IntentText from './IntentText'
// import draggable from 'vuedraggable'
import IntentPrefill from './IntentPrefill'

import ModalDialog from '@/components/elements/ModalDialog'
import specialtext from '@/components/elements/specialtext'
import uploadfile from '@/components/elements/uploadfile'
import MoveVertical from '@/components/elements/MoveVertical'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import AddGenericButton from '@/components/view/chatbot/AddGenericButton'
import IntentGenericManage from './IntentGenericManage'
import IntentGetstarted from '@/components/view/intent/IntentGetstarted'
import MessageViewer from '@/components/elements/MessageViewer'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import api from '@/api'
import Velocity from 'velocity-animate'
import dayjs from 'dayjs'
import { cloneDeep } from 'lodash'
import { ToggleButton } from 'vue-js-toggle-button'
import IntentVerifySlip from '@/components/view/intent/IntentVerifySlip'

export default {
  props: {
    value: {
      default: ''
    },
    isIgType: {
      default: false,
      type: Boolean
    },
    maxLength: {
      default: null
    },
    hasAlternative: {
      default: true,
      type: Boolean
    },
    isBroadCast: {
      dafault: false,
      type: Boolean
    },
    isWelcome: {
      dafault: false,
      type: Boolean
    },
    intentname: {
      default: ''
    },
    showMultipleChannel: {
      default: false
    },
    channel: {
      default: 'all'
    },
    availableBubbles: {},
    isHasPrefill: {
      default: true
    },
    isBeacon: {
      dafault: false,
      type: Boolean
    },
    followUp: {
      dafault: false,
      type: Boolean
    },
    messagesType: {
      default: ''
    },
    isIntent: {
      dafault: false,
      type: Boolean
    },
    isNotAltText: {
      dafault: false
    },
    isNotRatio: {
      dafault: false
    },
    groupType: {},
    customType: {},
    isLineShopping: {
      dafault: false,
      type: Boolean
    },
    isAdsPreview: {
      default: false,
      type: Boolean
    },
    isFirstAnnouncement: {
      default: false,
      type: Boolean
    },
    isVerifySlip: {
      default: false,
      type: Boolean
    },
    correct: {
      type: Array
    },
    incorrect: {
      type: Array
    },
    err: {
      type: Array
    },
    duplicate: {
      type: Array
    }
  },
  inject: ['$validator'],
  data: function() {
    return {
      addLimit: this.$store.getters.getPackage == 'premium' ? 10 : 5,
      group: '',
      intentItems: [],
      showEmoji: false,
      typingTimer: null,
      currentIndex: null,
      newButton: {
        title: '',
        type: 'web_url',
        url: ''
      },
      currentAlternative: 0,
      productlist: [],
      showSetting: false,
      input: {
        showMultipleChannel: false,
        randomStatus: false
      },
      timestamp: dayjs().format('x'),
      maxRandomBarWidth: 0
    }
  },
  components: {
    ToggleButton,
    IntentGroupItem,
    IntentText,
    // draggable,
    IntentPrefill,

    ModalDialog,
    specialtext,
    uploadfile,
    MoveVertical,
    AutoresizeTextarea,
    AddGenericButton,
    IntentGenericManage,
    IntentGetstarted,
    MessageViewer,
    ViewCartSummaryViewer,
    IntentVerifySlip
  },
  created: function() {
    this.onResize()
    this.group = this.value
    this.intentItems = this.group
  },
  mounted() {
    const vm = this
    vm.$set(vm.input, 'showMultipleChannel', vm.showMultipleChannel)
    if (vm.intentItems && vm.intentItems.length > 1) {
      vm.$set(vm.input, 'randomStatus', true)
    }

    if (vm.isOutOfTime) {
      vm.$set(vm.input, 'showMultipleChannel', false)
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    welcomeMessage() {
      let { messages } = this.$store.getters.welcomeMessage(this.channel)
      return messages
    },
    bubbleCount: function() {
      var vm = this

      if (vm.intentItems[vm.currentAlternative]) {
        var count = 0
        vm.intentItems[vm.currentAlternative].map(bubble => {
          if (bubble.type == 'welcome_message') {
            if (vm.welcomeMessage.messages && vm.welcomeMessage.messages[0]) {
              count += vm.welcomeMessage.messages[0].length
            } else {
              count++
            }
          } else {
            count++
          }
        })
        return count
      } else {
        return 0
      }
    },
    correctMsg: {
      get() {
        return this.correct
      },
      set(value) {
        this.$emit('update:correct', value)
      }
    },
    incorrectMsg: {
      get() {
        return this.incorrect
      },
      set(value) {
        this.$emit('update:incorrect', value)
      }
    },
    errMsg: {
      get() {
        return this.err
      },
      set(value) {
        this.$emit('update:err', value)
      }
    },
    duplicateMsg: {
      get() {
        return this.duplicate
      },
      set(value) {
        this.$emit('update:duplicate', value)
      }
    },
    isOutOfTime() {
      const advancedExpired = this.selectedBot.advanced_expireat || null
      if (!advancedExpired) {
        return true
      } else {
        let a = dayjs(advancedExpired)
        let b = dayjs()
        return b.diff(a, 'days') > 0
      }
    }
  },
  methods: {
    onResize() {
      if (this.$refs.randomBar) {
        let randomBarWidth = this.$refs.randomBar.clientWidth
        let addRandomBtnWidth = 48
        this.maxRandomBarWidth = randomBarWidth - addRandomBtnWidth
      }
    },
    onDeleteAlternative(alternative) {
      if (this.intentItems.length > 1) {
        this.intentItems.splice(alternative - 1, 1)
      }
      this.timestamp = dayjs().format('x')
    },
    toggleRandomStatus() {
      this.$set(this.input, 'randomStatus', !this.input.randomStatus)
    },
    closeRandomStatus() {
      this.$set(this.input, 'randomStatus', false)
    },
    changeSetting() {
      this.$emit('changeSetting', this.input)
      this.showSetting = false
      this.onResize()
    },
    beforeEnter: function(el) {
      el.style.opacity = 0
      // el.style.height = 0
    },
    enter: function(el, done) {
      setTimeout(() => {
        el.style.height = '100%'
        setTimeout(() => {
          Velocity(el, { opacity: 1, translateY: '10px' }, { complete: done, duration: 500 })
        }, 100)
      }, 600)
    },
    afterEnter: function(el) {
      //
    },
    beforeLeave: function(el) {
      el.style.opacity = 1
      // el.style.maxHeight = 'none'
    },
    leave: function(el, done) {
      Velocity(el, { opacity: 0, translateY: '-10px' }, { complete: done, duration: 500 })
    },
    afterLeave: function(el) {
      // el.style.maxHeight = 0
    },
    getProducts: function(callback) {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid
      }
      vm.productlist = []
      if (
        vm.selectedBot.useketshop == true &&
        vm.selectedBot.ketshop_api_key &&
        vm.selectedBot.ketshop_api_secret
      ) {
        data['ketshop_api_key'] = vm.selectedBot.ketshop_api_key
        data['ketshop_api_secret'] = vm.selectedBot.ketshop_api_secret
      }
      api.getProducts(data, function(error, response) {
        if (error) {
          console.error(error)
          callback()
          return
        }
        vm.productlist = response.productlist
        callback()
      })
    },
    nextAlternative: function() {
      // if (this.currentAlternative + 1 === this.intentItems.length) {
      var intent = cloneDeep(this.intentItems[this.currentAlternative])
      this.intentItems.push([])
      this.intentItems[this.currentAlternative + 1] = intent
      // }
      this.currentAlternative = this.currentAlternative + 1
      this.updateIntent()
    },
    addAlternativeMessnage: function() {
      this.intentItems.push([])
      this.currentAlternative = this.intentItems.length - 1
      this.updateIntent()
    },
    deleteAlternativeMessage: function(index) {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: 'Pattern' + (index + 1)
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            vm.intentItems.splice(index, 1)
            vm.currentAlternative = index - 1
            vm.updateIntent()
          }
        })
    },
    addIntentPrefill: function(index, subindex, prefill) {
      var vm = this
      let cursorPosition = this.$refs['answer_' + index + '_' + subindex][0].$el.selectionStart

      if (vm.intentItems[index][subindex].type === 'text') {
        vm.$set(
          vm.intentItems[index][subindex],
          'text',
          [
            vm.intentItems[index][subindex].text.slice(0, cursorPosition),
            '{' + prefill + '}',
            vm.intentItems[index][subindex].text.slice(cursorPosition)
          ].join('')
        )
      } else if (vm.intentItems[index][subindex].type == 'button') {
        vm.$set(
          vm.intentItems[index][subindex],
          'text',
          [
            vm.intentItems[index][subindex].text.slice(0, cursorPosition),
            '{' + prefill + '}',
            vm.intentItems[index][subindex].text.slice(cursorPosition)
          ].join('')
        )
      }
      vm.updateIntent()
    },
    addIntentItem: function(type, index) {
      if (this.bubbleCount >= this.addLimit) {
        return false
      }
      if (type == 'text') {
        this.intentItems[index].push({
          text: '',
          type: type
        })
      } else if (type == 'button') {
        this.intentItems[index].push({
          text: '',
          buttons: [],
          type: type
        })
      } else if (type == 'image') {
        this.intentItems[index].push({
          image_url: '',
          type: type
        })
      } else if (type == 'generic') {
        this.intentItems[index].push({
          data: [
            {
              image_url: null,
              title: '',
              subtitle: '',
              buttons: []
            }
          ],
          altText: 'You received a message',
          type: type
        })
      } else if (type == 'welcome_message') {
        this.intentItems[index].push({
          type: type
        })
      } else if (type == 'viewsummary') {
        if (this.productlist.length == 0) {
          return false
        }
        this.intentItems[index].push({
          type: 'text',
          text: '{viewsummary}'
        })
      }
      this.updateIntent()
    },
    onDelete: function(index, subindex) {
      this.intentItems[index].splice(subindex, 1)
      this.updateIntent()
    },

    onMove: function(index, subindex, direction) {
      var vm = this
      if (direction == 'up') {
        vm.intentItems[index].splice(subindex, 0, vm.intentItems[index].splice(subindex - 1, 1)[0])
      } else if (direction == 'down') {
        vm.intentItems[index].splice(subindex, 0, vm.intentItems[index].splice(subindex + 1, 1)[0])
      }
      this.updateIntent()
    },
    onTyping: function() {
      // clearTimeout(this.typingTimer);
      // this.typingTimer = setTimeout(this.updateIntent(), 1000)
      this.updateIntent()
    },
    updateIntent: function() {
      let vm = this
      vm.group = vm.intentItems
    },
    addNewButton: function(index, subindex, payload) {
      if (this.intentItems[index][subindex].buttons.length < 3) {
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.intentItems[index][subindex].buttons.push(payload)
        this.newButton = {
          title: '',
          type: 'web_url',
          url: ''
        }
        this.updateIntent()
      }
    },
    editButton: function(index, subindex, bindex, payload) {
      if (this.intentItems[index][subindex].buttons[bindex]) {
        // this.intentItems[index].value.buttons[index] = payload
        if (payload.type == 'web_url') {
          delete payload.payload
        } else if (payload.type == 'postback' || payload.type == 'phone_number') {
          delete payload.url
        }
        this.$set(this.intentItems[index][subindex].buttons, bindex, payload)
        this.updateIntent()
      }
    },
    deleteButton: function(index, subindex, bindex) {
      // if (this.intentItems.length >= 1) {
      //     return false
      // }
      this.intentItems[index][subindex].buttons.splice(bindex, 1)
      this.updateIntent()
    }
  },
  watch: {
    group: function() {
      this.$emit('input', this.group)
    },
    value: function() {
      var vm = this
      vm.group = vm.value
      vm.intentItems = vm.group
    }
  }
}
</script>

<style lang="scss" scoped>
.intent-group-item {
  transition: height ease 2s;
  -webkit-transition: height ease 2s;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentGroup.vue